"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var format_1 = require("@/utils/format");
var ResultTableSort_1 = require("@/pages/common/states/ResultTableSort");
var resultTable = function (props) {
    var renderRow = function (props, item, i) {
        var currencyCode = props.currencyCode;
        var bedFields = item.amenities.filter(function (it) { return it.key === 'bed'; });
        var bathFields = item.amenities.filter(function (it) { return it.key === 'bath'; });
        var beds = bedFields.length ? bedFields[0].value : -1;
        var baths = bathFields.length ? bathFields[0].value : -1;
        var netsize = item.sizeSaleable;
        var grosssize = item.sizeGross;
        var dateFull = item.lastUpdated ? format_1.default.date(format_1.default.dateStringToDate(item.lastUpdated.toString())) : '-';
        var renderPrice = function (item, prefix, type, lang) {
            var price = props.type === SfilterTypeGroup_1.ListingPurposeType.Sale ? item.salePrice : item.leasePrice;
            if (price <= 0 || item.isSubjectToOffer)
                return props.t.subjectToOffer;
            if (type === SfilterTypeGroup_1.ListingPurposeType.Sale) {
                return format_1.default.currencySale(price, lang, prefix + " ");
            }
            return format_1.default.currencyLease(price, lang, prefix + " ");
        };
        var renderImage = function (item, prefix, type, lang) {
            var staticMap = "https://maps.googleapis.com/maps/api/staticmap?center=" + item.lat + "," + item.lng + "&zoom=16&size=300x200&markers=color:0x00b0a8|" + item.lat + "," + item.lng + "&maptype=roadmap&style=feature:all|element:labels&key=" + props.googleApikey;
            var altText = item.building;
            var priceAlText = renderPrice(item, prefix, type, lang);
            var imgAttr = { alt: altText + " - " + (item.type === SfilterTypeGroup_1.SfilterType.RENT ? props.t.forRent : props.t.forRent) + (netsize ? " - " + netsize + " " + props.t.sqft : '') + " - " + priceAlText + " - #" + item.referenceId };
            return item.images.length && item.images[0].path
                ? (React.createElement("img", __assign({}, imgAttr, { src: item.images[0].path })))
                : (item.lat
                    ? (React.createElement("img", __assign({}, imgAttr, { src: staticMap })))
                    : null);
        };
        var onFavClick = function (e) {
            e.preventDefault();
            e.stopPropagation();
            props.onFavClick(item);
        };
        var onRowContactClicked = function (e) {
            e.preventDefault();
            e.stopPropagation();
            props.onEnquireClick(item);
        };
        var onRowClicked = function (e) {
            e.preventDefault();
            e.stopPropagation();
            props.onItemClick(item);
        };
        return (React.createElement("tr", { onClick: onRowClicked, key: i },
            React.createElement("td", null,
                React.createElement("div", { className: "c-table__cell c-table__cell--img" }, renderImage(item, currencyCode, props.type, props.lang))),
            React.createElement("td", { onClick: onFavClick }, item.isSaved ? (React.createElement("span", { className: "fas fa-heart" })) : (React.createElement("span", { className: "fal fa-heart" }))),
            React.createElement("td", null, item.building),
            React.createElement("td", null, renderPrice(item, '', props.type, props.lang)),
            React.createElement("td", null,
                React.createElement("div", { className: "c-table__cell" },
                    React.createElement("div", { className: "c-table__inline" }, netsize ? format_1.default.comma(netsize) : '-'),
                    grosssize ? (React.createElement("div", { className: "c-table__caption" },
                        format_1.default.comma(grosssize),
                        props.t.gfa)) : null)),
            React.createElement("td", null, beds > -1 ? beds : '-'),
            React.createElement("td", null, baths > -1 ? baths : '-'),
            React.createElement("td", null,
                React.createElement("div", { className: "c-table__cell" },
                    React.createElement("span", null, dateFull)),
                React.createElement("div", { className: "c-table__caption" },
                    "#",
                    item.referenceId)),
            React.createElement("td", null,
                React.createElement("div", { className: "c-table__cell c-table__cell--center" },
                    React.createElement("button", { onClick: onRowContactClicked, className: "o-btn o-btn--primary" },
                        React.createElement("span", { className: "fal fa-envelope" }),
                        "\u00A0",
                        props.t.contact)))));
    };
    var onSortClick = function (column) { return function (e) {
        e.preventDefault();
        e.stopPropagation();
        props.onSortClick(column);
    }; };
    var renderSortIcon = function (props, column) {
        if (props.currentSortColumn === column) {
            if (props.currentSortOrder === ResultTableSort_1.AvailableSortOrder.ASC) {
                return (React.createElement("span", { className: "fal fa-sort-amount-up-alt" }));
            }
            return (React.createElement("span", { className: "fal fa-sort-amount-down-alt" }));
        }
        return (React.createElement("span", { className: "fal fa-sort-alt" }));
    };
    return (React.createElement("table", { className: "c-table" },
        React.createElement("thead", null,
            React.createElement("tr", null,
                React.createElement("td", null),
                React.createElement("td", null),
                React.createElement("td", { onClick: onSortClick(ResultTableSort_1.AvailableSortColumn.NAME) },
                    React.createElement("div", { className: "c-table__inline" },
                        React.createElement("span", null, props.t.building),
                        renderSortIcon(props, ResultTableSort_1.AvailableSortColumn.NAME))),
                React.createElement("td", { onClick: onSortClick(props.type === SfilterTypeGroup_1.ListingPurposeType.Sale ? ResultTableSort_1.AvailableSortColumn.SALE_PRICE : ResultTableSort_1.AvailableSortColumn.LEASE_PRICE) },
                    React.createElement("div", { className: "c-table__inline" },
                        React.createElement("span", null, props.t.price),
                        renderSortIcon(props, props.type === SfilterTypeGroup_1.ListingPurposeType.Sale ? ResultTableSort_1.AvailableSortColumn.SALE_PRICE : ResultTableSort_1.AvailableSortColumn.LEASE_PRICE))),
                React.createElement("td", { onClick: onSortClick(ResultTableSort_1.AvailableSortColumn.NET_SIZE) },
                    React.createElement("div", { className: "c-table__inline" },
                        React.createElement("span", null, props.t.size),
                        renderSortIcon(props, ResultTableSort_1.AvailableSortColumn.NET_SIZE))),
                React.createElement("td", { onClick: onSortClick(ResultTableSort_1.AvailableSortColumn.BED) },
                    React.createElement("div", { className: "c-table__inline" },
                        React.createElement("span", null, props.t.beds),
                        renderSortIcon(props, ResultTableSort_1.AvailableSortColumn.BED))),
                React.createElement("td", { onClick: onSortClick(ResultTableSort_1.AvailableSortColumn.BATH) },
                    React.createElement("div", { className: "c-table__inline" },
                        React.createElement("span", null, props.t.baths),
                        renderSortIcon(props, ResultTableSort_1.AvailableSortColumn.BATH))),
                React.createElement("td", { onClick: onSortClick(ResultTableSort_1.AvailableSortColumn.UPDATE) },
                    React.createElement("div", { className: "c-table__inline" },
                        React.createElement("span", null, props.t.date),
                        renderSortIcon(props, ResultTableSort_1.AvailableSortColumn.UPDATE))),
                React.createElement("td", null))),
        React.createElement("tbody", null, props.properties.map(function (it, i) { return renderRow(props, it, i); }))));
};
exports.default = resultTable;
